import { PackageFormats } from "models/dto/ZoomiLxp/Utilities/Enumerations/PackageFormats";

export const getScormVersion = (scormVersion: number): string =>
	scormVersion === 0 ? "V1p3" : PackageFormats[scormVersion];

export const getRteRequired = (scormVersion: number): boolean => scormVersion !== 0;
